<template>
  <paginate
    :click-handler="onChangePage"
    :page-count="pages"
    :prev-text="$t('prev')"
    :next-text="$t('next')"
    :container-class="'pagination'"
    :page-class="'page-item'"
    :page-link-class="'page-link'"
    :next-class="'page-item'"
    :next-link-class="'page-link'"
    :prev-class="'page-item'"
    :prev-link-class="'page-link'"
    />
</template>

<script>
export default {
  name: 'dx-paginate',
  props: {
    pages: Number
  },
  methods: {
    onChangePage (page) {
      this.$emit('change-page', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxPaginate.vue